/* FAIR — Story Bubbles viewer. Instagram-style, optimised for smoothness. */
(function () {
  'use strict';

  var VIEWED_KEY = 'fair_stories_viewed_v1';

  function getViewed() {
    try { return JSON.parse(localStorage.getItem(VIEWED_KEY) || '[]'); } catch (e) { return []; }
  }
  function addViewed(id) {
    try {
      var v = getViewed();
      if (v.indexOf(id) === -1) { v.push(id); localStorage.setItem(VIEWED_KEY, JSON.stringify(v)); }
    } catch (e) {}
  }

  function StoryViewer(root) {
    this.root = root;
    this.bubbles = Array.prototype.slice.call(root.querySelectorAll('[data-sb-bubble]'));
    this.viewer = root.querySelector('[data-sb-viewer]');
    if (!this.viewer || !this.bubbles.length) return;
    this.stage = this.viewer.querySelector('[data-sb-stage]');
    this.slides = Array.prototype.slice.call(this.viewer.querySelectorAll('[data-sb-slide]'));
    this.videos = this.slides.map(function (s) { return s.querySelector('video'); });
    this.progressEl = this.viewer.querySelector('[data-sb-progress]');
    this.titleEl = this.viewer.querySelector('[data-sb-title]');
    this.avatarEl = this.viewer.querySelector('[data-sb-avatar]');
    this.ctaEl = this.viewer.querySelector('[data-sb-cta]');
    this.muteBtn = this.viewer.querySelector('[data-sb-mute]');

    this.current = -1;
    this.raf = null;
    this.muted = false;
    this.heldPaused = false;

    this._buildSegments();
    this._bind();
    this._applyViewed();
  }

  StoryViewer.prototype._buildSegments = function () {
    var html = '';
    for (var i = 0; i < this.slides.length; i++) {
      html += '<div class="sb-progress-seg"><div class="sb-progress-seg__fill" data-sb-fill></div></div>';
    }
    this.progressEl.innerHTML = html;
    this.fills = Array.prototype.slice.call(this.progressEl.querySelectorAll('[data-sb-fill]'));
  };

  StoryViewer.prototype._applyViewed = function () {
    var viewed = getViewed();
    this.bubbles.forEach(function (b) {
      var ring = b.querySelector('.sb__ring');
      if (ring && viewed.indexOf(b.dataset.storyId) !== -1) ring.classList.add('is-viewed');
    });
  };

  StoryViewer.prototype._bind = function () {
    var self = this;
    this.bubbles.forEach(function (b, i) {
      b.addEventListener('click', function () { self.open(i); });
    });

    this.viewer.querySelectorAll('[data-sb-close]').forEach(function (el) {
      el.addEventListener('click', function () { self.close(); });
    });
    var prevZone = this.viewer.querySelector('[data-sb-prev]');
    var nextZone = this.viewer.querySelector('[data-sb-next]');
    if (prevZone) prevZone.addEventListener('click', function () { self.prev(); });
    if (nextZone) nextZone.addEventListener('click', function () { self.next(); });
    if (this.muteBtn) this.muteBtn.addEventListener('click', function (e) { e.stopPropagation(); self.toggleMute(); });

    // video events
    this.videos.forEach(function (v, i) {
      if (!v) return;
      v.addEventListener('ended', function () { if (i === self.current) self.next(); });
      v.addEventListener('waiting', function () { if (i === self.current) self.slides[i].classList.add('is-buffering'); });
      v.addEventListener('playing', function () { self.slides[i].classList.remove('is-buffering'); });
      v.addEventListener('canplay', function () { self.slides[i].classList.remove('is-buffering'); });
    });

    // keyboard
    document.addEventListener('keydown', function (e) {
      if (!self.viewer.classList.contains('is-open')) return;
      if (e.key === 'Escape') self.close();
      else if (e.key === 'ArrowRight') self.next();
      else if (e.key === 'ArrowLeft') self.prev();
      else if (e.key === ' ') { e.preventDefault(); self.heldPaused ? self._resume() : self._holdPause(); }
    });

    // gestures on stage (hold to pause, swipe down to close, tap zones handled by buttons)
    var sx = 0, sy = 0, st = 0, holdTimer = null, moved = false;
    this.stage.addEventListener('pointerdown', function (e) {
      sx = e.clientX; sy = e.clientY; st = Date.now(); moved = false;
      holdTimer = setTimeout(function () { self._holdPause(); }, 250);
    });
    this.stage.addEventListener('pointermove', function (e) {
      if (Math.abs(e.clientX - sx) > 10 || Math.abs(e.clientY - sy) > 10) {
        moved = true;
        if (holdTimer) { clearTimeout(holdTimer); holdTimer = null; }
      }
    });
    var endHandler = function (e) {
      if (holdTimer) { clearTimeout(holdTimer); holdTimer = null; }
      var dy = e.clientY - sy;
      var dx = e.clientX - sx;
      if (self.heldPaused) { self._resume(); return; }
      if (dy > 90 && Math.abs(dy) > Math.abs(dx)) { self.close(); return; }
    };
    this.stage.addEventListener('pointerup', endHandler);
    this.stage.addEventListener('pointercancel', function () {
      if (holdTimer) { clearTimeout(holdTimer); holdTimer = null; }
      if (self.heldPaused) self._resume();
    });

    // pause when tab hidden
    document.addEventListener('visibilitychange', function () {
      if (!self.viewer.classList.contains('is-open')) return;
      if (document.hidden) self._holdPause(); else self._resume();
    });
  };

  StoryViewer.prototype.open = function (i) {
    this.viewer.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    this.go(i);
  };

  StoryViewer.prototype.go = function (i) {
    if (i < 0) i = 0;
    if (i >= this.slides.length) { this.close(); return; }

    // stop previous
    if (this.current >= 0 && this.videos[this.current]) {
      var pv = this.videos[this.current];
      pv.pause();
      this.slides[this.current].classList.remove('is-active', 'is-buffering');
    }
    this._stopTick();

    this.current = i;
    this.heldPaused = false;

    // reset fills
    for (var k = 0; k < this.fills.length; k++) {
      this.fills[k].style.width = k < i ? '100%' : '0%';
    }

    var slide = this.slides[i];
    var video = this.videos[i];
    slide.classList.add('is-active');

    // header
    if (this.titleEl) this.titleEl.textContent = slide.dataset.title || '';
    if (this.avatarEl) {
      var av = slide.dataset.avatar;
      this.avatarEl.innerHTML = av ? '<img src="' + av + '" alt="">' : '';
    }
    // cta
    if (this.ctaEl) {
      var url = slide.dataset.ctaUrl;
      var txt = slide.dataset.ctaText;
      if (url) {
        this.ctaEl.href = url;
        this.ctaEl.querySelector('[data-sb-cta-text]').textContent = txt || 'Shop';
        this.ctaEl.classList.add('is-visible');
      } else {
        this.ctaEl.classList.remove('is-visible');
      }
    }

    addViewed(slide.dataset.storyId);
    var ring = this.bubbles[i] && this.bubbles[i].querySelector('.sb__ring');
    if (ring) ring.classList.add('is-viewed');

    // preload next
    this._preload(i + 1);

    // play
    if (video) {
      video.muted = this.muted;
      video.currentTime = 0;
      video.preload = 'auto';
      var self = this;
      var p = video.play();
      if (p && p.catch) {
        p.catch(function () {
          // autoplay with sound blocked -> mute and retry
          self.muted = true;
          self._syncMuteIcon();
          video.muted = true;
          video.play().catch(function () {});
        });
      }
      this._startTick();
    }
  };

  StoryViewer.prototype._preload = function (i) {
    if (i < 0 || i >= this.videos.length) return;
    var v = this.videos[i];
    if (v) { v.preload = 'auto'; try { v.load(); } catch (e) {} }
  };

  StoryViewer.prototype._startTick = function () {
    var self = this;
    var video = this.videos[this.current];
    var fill = this.fills[this.current];
    if (!video || !fill) return;
    function step() {
      if (video.duration && !isNaN(video.duration)) {
        var pct = (video.currentTime / video.duration) * 100;
        fill.style.width = Math.min(pct, 100) + '%';
      }
      self.raf = requestAnimationFrame(step);
    }
    this.raf = requestAnimationFrame(step);
  };

  StoryViewer.prototype._stopTick = function () {
    if (this.raf) { cancelAnimationFrame(this.raf); this.raf = null; }
  };

  StoryViewer.prototype.next = function () { this.go(this.current + 1); };
  StoryViewer.prototype.prev = function () {
    var v = this.videos[this.current];
    if (v && v.currentTime > 1.2) { v.currentTime = 0; return; }
    this.go(this.current - 1 < 0 ? 0 : this.current - 1);
  };

  StoryViewer.prototype.close = function () {
    this._stopTick();
    var v = this.videos[this.current];
    if (v) v.pause();
    if (this.current >= 0) this.slides[this.current].classList.remove('is-active', 'is-buffering');
    this.viewer.classList.remove('is-open');
    document.body.style.overflow = '';
    this.current = -1;
  };

  StoryViewer.prototype.toggleMute = function () {
    this.muted = !this.muted;
    var v = this.videos[this.current];
    if (v) v.muted = this.muted;
    this._syncMuteIcon();
  };
  StoryViewer.prototype._syncMuteIcon = function () {
    if (!this.muteBtn) return;
    this.muteBtn.setAttribute('data-muted', this.muted ? 'true' : 'false');
    var on = this.muteBtn.querySelector('[data-icon-unmuted]');
    var off = this.muteBtn.querySelector('[data-icon-muted]');
    if (on) on.style.display = this.muted ? 'none' : 'block';
    if (off) off.style.display = this.muted ? 'block' : 'none';
  };

  StoryViewer.prototype._holdPause = function () {
    var v = this.videos[this.current];
    if (v) v.pause();
    this._stopTick();
    this.heldPaused = true;
    this.stage.classList.add('is-paused');
  };
  StoryViewer.prototype._resume = function () {
    var v = this.videos[this.current];
    if (v) v.play().catch(function () {});
    this.heldPaused = false;
    this.stage.classList.remove('is-paused');
    this._startTick();
  };

  function boot() {
    document.querySelectorAll('[data-sb-root]').forEach(function (r) { new StoryViewer(r); });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else { boot(); }
})();
